import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalActions, chartsActions, yodleeConsentActions } from '../../../redux/root-action';
import { responseStatus } from '../../../utils/constants';
import ReactModalHeader from '../../Modal/ReactModalHeader';

const YodleeContainer = styled.div`
  text-align: center;
  .yodlee-iframe-container .yodlee-iframe {
    max-height: 485px !important;
  }
`;

const iFrameScript = '/etc.clientlibs/workplace-fdi/components/content/iframe-modal/clientlibs.js';

class YodleeIFrame extends Component<any> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);
    this.state = { content: undefined };
  }

  async componentDidMount() {
    const response = await fetch(
      '/content/workplace/en/participant/authors/Modals/sub-navigation/accounts/yodlee-iframe.html',
    );
    const data = await response.text();
    const script = document.createElement('script');
    script.src = iFrameScript;
    script.async = true;
    const scripts = document.getElementsByTagName('script');
    let iframeScriptLoaded = false;
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src === iFrameScript) {
        iframeScriptLoaded = true;
      }
    }
    if (!iframeScriptLoaded) {
      document.body.appendChild(script);
    }
    this.setState({ content: data });
  }

  componentDidUpdate(prevProps: any) {
    const { postSimulation, yodleeConsent, hideModal } = this.props;
    if (
      prevProps.yodleeConsent.yodleeRefresh !== yodleeConsent.yodleeRefresh &&
      yodleeConsent.yodleeRefresh === responseStatus.SUCCESS
    ) {
      hideModal();
      postSimulation({});
    } else if (
      prevProps.yodleeConsent.yodleeRefresh !== yodleeConsent.yodleeRefresh &&
      yodleeConsent.yodleeRefresh === responseStatus.ERROR
    ) {
      hideModal();
    }
  }

  handleCloseIconClick = () => {
    const { yodleeRefresh } = this.props;
    yodleeRefresh();
  };

  render() {
    const { content } = this.state;
    return (
      <React.Fragment>
        <ReactModalHeader showClose={true} handleCloseIconClick={this.handleCloseIconClick} />
        <YodleeContainer>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </YodleeContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ yodleeConsent }: any) => {
  return {
    yodleeConsent,
  };
};

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  postSimulation: chartsActions.postSimulation,
  yodleeRefresh: yodleeConsentActions.yodleeRefresh,
})(YodleeIFrame);
